const initialState = {
	groupInformation: null,
	locationInformation: null,
	currentGroup: null
};

export default initialState;
